const initialState = {
  isNewTracking: false,
};

export default initialState;
